import React from 'react'
import Radium from 'radium'
import { Toggle } from 'libreact/lib/Toggle'

import colors from '../../../theme/colors'
import borderRadius from '../../../theme/borderRadius'
import boxShadow from '../../../theme/boxShadow'

import Width from '../../Width'
import Rows from '../Rows'

import Arrow from '../../Arrow'
import onClick from './lib/onClick'

export default Radium((props) => (
  <Width>
    {({ isSmall }) => (
      <Toggle init>
        {({ on, toggle }) => (
          <div style={styles.container}>
            <div
              style={[
                styles.title,
                isSmall && styles.small.title,
              ]}
              onClick={onClick(isSmall, toggle)}
            >
              Monthly Budget Review {isSmall && <Arrow on={on} />}
            </div>
            {(!isSmall || on) && <Rows {...props} />}
          </div>
        )}
      </Toggle>
    )}
  </Width>
))

const styles = {
  container: {
    padding: '0 20px',
    border: `1px solid ${colors.green}`,
    backgroundColor: colors.white,
    borderRadius,
    boxShadow,
  },
  title: {
    color: colors.green,
    fontSize: '18px',
    fontWeight: 700,
    padding: '25px 0',
    textAlign: 'center',
  },
  small: {
    title: {
      cursor: 'pointer',
    },
  },
}
